import { taggedTemplateLiteral as _taggedTemplateLiteral, slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Theme from '../../Theme/index.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var Wrapper = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var Text = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  cursor: pointer;\n"])), Theme.colors.lightBlue);
var TooltipContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 2;\n  top: 100%;\n  left: 50%;\n  transform: translate(-50%, 0);\n  padding-top: 15px;\n"])));
var TooltipContent = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 200px;\n  background-color: white;\n  color: ", ";\n  padding: 16px 20px;\n  background-color: white;\n  border: 1px solid ", ";\n\n  &:after,\n  &:before {\n    bottom: 100%;\n    left: 50%;\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  &:after {\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: white;\n    border-width: 10px;\n    margin-left: -10px;\n  }\n\n  &:before {\n    border-color: rgba(151, 151, 151, 0);\n    border-bottom-color: ", ";\n    border-width: 11px;\n    margin-left: -11px;\n  }\n"])), Theme.colors.primaryOpacity, Theme.colors.deepGrey, Theme.colors.deepGrey);
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    text = _ref.text;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hovering = _useState2[0],
    setHovering = _useState2[1];
  return /*#__PURE__*/React__default.createElement(Wrapper, {
    onMouseEnter: function onMouseEnter() {
      return setHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovering(false);
    }
  }, /*#__PURE__*/React__default.createElement(Text, null, children), hovering && text ? /*#__PURE__*/React__default.createElement(TooltipContainer, null, /*#__PURE__*/React__default.createElement(TooltipContent, null, text)) : null);
};
Tooltip.propTypes = {
  text: PropTypes.string.isRequired
};

export { Wrapper, Tooltip as default };
